import { lazy } from "react";
import ComingSoon from "../components/common/ComingSoon";
import PageWrapper from "../components/common/PageWrapper";
import PrivateRoute from "../components/common/RoutesWrappers/PrivateRoute";
import PublicRoute from "../components/common/RoutesWrappers/PublicRoute";
import { browserRoutes } from "./browserRoutes";

const Login = lazy(() => import("../pages/Auth/Login"));
const ForgotPassword = lazy(() => import("../pages/Auth/ForgotPassword"));
const ResetPassword = lazy(() => import("../pages/Auth/ResetPassword"));
const Profile = lazy(() => import("../pages/Profile"));
const ChangePassword = lazy(() => import("../pages/Auth/ChangePassword"));
const Events = lazy(() => import("../pages/Events"));
const AddEditEvents = lazy(() => import("../pages/Events/AddEditEvents"));
const ViewEvents = lazy(() => import("../pages/Events/ViewEvent"));
const Users = lazy(() => import("../pages/Users"));
const Rides = lazy(() => import("../pages/Trips"));
const ViewRide = lazy(() => import("../pages/Trips/ViewTrip"));
const Clubs = lazy(() => import("../pages/Clubs"));
const ViewClub = lazy(() => import("../pages/Clubs/ViewClub"));
const StaticPage = lazy(() => import("../pages/StaticPage"));
const EditStaticPage = lazy(() => import("../pages/StaticPage/EditStaticPage"));
const Interest = lazy(() => import("../pages/Interests"));
const Vehicle = lazy(() => import("../pages/Vehicle"));
const ViewUser = lazy(() => import("../pages/Users/ViewUser"));
const Tags = lazy(() => import("../pages/Tags"));
const Highlight = lazy(() => import("../pages/Highlight"));
const AddPhtotoVedio = lazy(() => import("../pages/Events/AddEditPhotoVedio"));
const FAQs = lazy(() => import("../pages/FAQS"));
const ContactUs = lazy(() => import("../pages/ContactUs"));
const Category = lazy(() => import("../pages/Category"));
const Facility = lazy(() => import("../pages/Facility"));
const AddEditTimeSlot = lazy(() => import("../pages/Events/AddEditTimeSlots"));
const VehicalBrand = lazy(() => import("../pages/VehicalBrand"));
const VehicleBrandModal = lazy(() =>
  import("../pages/VehicalBrand/ViewBrandModels")
);
const Analytics = lazy(() => import("../pages/Analytics"));
const NotificationManagement = lazy(() =>
  import("../pages/NotificationManagement")
);
const StickerVerificationHistory = lazy(() =>
  import("../pages/StickerVerificationHistory")
);
const PrivacyPolicy = lazy(() => import("../pages/PrivacyPolicy"));
const TermsAndConditions = lazy(() => import("../pages/TermsAndConditions"));

export const routerConfig = {
  // index routes
  indexRoutes: [
    {
      path: browserRoutes?.login,
      component: (
        <PublicRoute>
          <Login />
        </PublicRoute>
      ),
    },
    {
      path: browserRoutes?.forgotPassword,
      component: (
        <PublicRoute>
          <ForgotPassword />
        </PublicRoute>
      ),
    },
    {
      path: browserRoutes?.resetPassword + "/:verificationToken",
      component: (
        <PublicRoute>
          <ResetPassword />
        </PublicRoute>
      ),
    },
  ],
  // dashboard routes
  dashboardRoutes: [
    {
      path: browserRoutes?.profile,
      component: (
        <PrivateRoute>
          <Profile />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.changePassword,
      component: (
        <PrivateRoute>
          <ChangePassword />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.dashboard,
      component: (
        <PrivateRoute>
          <PageWrapper>
            <Analytics />
          </PageWrapper>
        </PrivateRoute>
      ),
    },
    // events
    {
      path: browserRoutes?.events,
      component: (
        <PrivateRoute>
          <Events />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.addEvents,
      component: (
        <PrivateRoute>
          <AddEditEvents />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.editEvents,
      component: (
        <PrivateRoute>
          <AddEditEvents />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.viewEvents,
      component: (
        <PrivateRoute>
          <ViewEvents />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.addEditTimeSlot,
      component: (
        <PrivateRoute>
          <AddEditTimeSlot />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.addPhtotoVedio,
      component: (
        <PrivateRoute>
          <AddPhtotoVedio />
        </PrivateRoute>
      ),
    },
    // users
    {
      path: browserRoutes?.users,
      component: (
        <PrivateRoute>
          <Users />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.viewUser,
      component: (
        <PrivateRoute>
          <ViewUser />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.vehicle,
      component: (
        <PrivateRoute>
          <Vehicle />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.addVehicle,
      component: (
        <PrivateRoute>
          <PageWrapper>
            <ComingSoon />
          </PageWrapper>
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.brand,
      component: (
        <PrivateRoute>
          <VehicalBrand />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.viewBrandModels,
      component: (
        <PrivateRoute>
          <VehicleBrandModal />
        </PrivateRoute>
      ),
    },
    // rides
    {
      path: browserRoutes?.rides,
      component: (
        <PrivateRoute>
          <Rides />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.viewRides,
      component: (
        <PrivateRoute>
          <ViewRide />
        </PrivateRoute>
      ),
    },
    // daily tips
    {
      path: browserRoutes?.clubs,
      component: (
        <PrivateRoute>
          <Clubs />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.viewClub,
      component: (
        <PrivateRoute>
          <ViewClub />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.faqs,
      component: (
        <PrivateRoute>
          <FAQs />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.interest,
      component: (
        <PrivateRoute>
          <Interest />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.tags,
      component: (
        <PrivateRoute>
          <Tags />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.highlight,
      component: (
        <PrivateRoute>
          <Highlight />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.contactUs,
      component: (
        <PrivateRoute>
          <ContactUs />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.category,
      component: (
        <PrivateRoute>
          <Category />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.facility,
      component: (
        <PrivateRoute>
          <Facility />
        </PrivateRoute>
      ),
    },
    // Static Page
    {
      path: browserRoutes?.staticPage,
      component: (
        <PrivateRoute>
          <StaticPage />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.editStaticPage,
      component: (
        <PrivateRoute>
          <EditStaticPage />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.notification,
      component: (
        <PrivateRoute>
          <NotificationManagement />
        </PrivateRoute>
      ),
    },
    {
      path: browserRoutes?.stickerVerificationHistory,
      component: (
        <PrivateRoute>
          <StickerVerificationHistory />
        </PrivateRoute>
      ),
    },
  ],

  staticRoutes: [
    {
      path: browserRoutes?.privacyPolicy,
      component: <PrivacyPolicy />,
    },
    {
      path: browserRoutes?.termsAndConditions,
      component: <TermsAndConditions />,
    },
  ],
};
